import * as RadixToast from '@radix-ui/react-toast';

const Toast = ({ title, description, open, onOpenChange, type='info' }) => (
  <RadixToast.Root className={`toast toast--${type}`} open={open} onOpenChange={onOpenChange}>
    {title && <RadixToast.Title className="toast__title">{title}</RadixToast.Title>}
    {description && (
      <RadixToast.Description className="toast__text">{description}</RadixToast.Description>
    )}
  </RadixToast.Root>
);

export default Toast;
